import { BASE_TIMEOFF_TYPE_IDENTIFIERS } from 'utils/constants/timeOffType';
import type { IOrganizationTimeOffSettings } from 'utils/organization/timeOffSettings/timeOffSettingsTypes';

export const timeOffSettingsDefault: IOrganizationTimeOffSettings = {
  active: [...BASE_TIMEOFF_TYPE_IDENTIFIERS],
  custom: [],
} as const;

export const timeOffSettingsDefaultString = JSON.stringify(timeOffSettingsDefault);
